export const defaultMusicVolumeLevel = 100;
export const defaultSoundVolumeLevel = 100;
export const defaultVideoExtractVolumeLevel = 100;
